import apiService from '../../../apiService'
import Notification from '../../../../../../../../resources/js/notification'

export default {
  namespaced: true,
  state: {
    unpaidDomains: []
  },
  mutations: {
    set (state, unpaidDomains) {
      state.unpaidDomains = unpaidDomains
    }
  },
  actions: {
    fetch ({ commit }) {
      apiService.getClientUnpaidDomains()
        .then(response => {
          commit('set', response.data.domains)
          // commit('set', ['test'])
          window.vue.$emit('clientUnpaidDomainsLoaded')
        })
        .catch(() => {
          Notification.notifyError({
            title: 'Ошибка',
            content: 'Не удалось загрузить список неоплаченных доменов клиента.'
          })
        })
    }
  },
  getters: {
    hasUnpaidDomains: state => state.unpaidDomains.length > 0
  }
}
